import React, { useState, useEffect } from 'react';
import { getSoyEarlyAdjustedGroups, getSoyEarlyStats } from '../../lib/api';
import { AdjustmentTab } from '../../components/AdjustmentTab';
import { getChartColors } from '../../services/chart-colors';

export function EarlyAdjustmentsTab(props) {
  const {
    onLoad,
    onGroupsAdjustment,
    onFieldAdjustment,
    field,
    ...passThrough
  } = props;

  const [stats, setStats] = useState(null);
  const [fieldAdjustment, setFieldAdjustment] = useState(0);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    Promise.all([
      getSoyEarlyStats(field.aaManagedId),
      getSoyEarlyAdjustedGroups(field.aaManagedId),
    ])
      .then(([earlyStats, earlyGroups]) => {
        if (earlyStats) {
          setStats(earlyStats);
          setGroups(earlyGroups);
          setFieldAdjustment(field.earlyAdjustmentFactor || 0);
        }

        onLoad('early', earlyGroups, field.earlyAdjustmentFactor);
      })
      .catch(() => onLoad('early'));
  }, [field, onLoad]);

  return (
    stats && (
      <AdjustmentTab
        {...passThrough}
        floor={100000}
        ceiling={200000}
        multipleOf={5000}
        stats={stats}
        groups={groups}
        fieldAdjustment={fieldAdjustment}
        colors={getChartColors('soyrx-early')}
        xLabel="Rate"
        onGroupsAdjustment={(newGroups) =>
          onGroupsAdjustment('early', newGroups)
        }
        onFieldAdjustment={(adjustment) =>
          onFieldAdjustment('early', adjustment)
        }
      />
    )
  );
}
